export type ServiceGroup = {
  id: string
  eyebrow: string
  title: string
  description: string
  image: string
  items: string[]
}

export const serviceGroups: ServiceGroup[] = [
  {
    id: 'hardware',
    eyebrow: '01',
    title: 'Hardware & Installation',
    description:
      'The jewelry of the home. We source, supply, and install hardware to the millimeter — every pull level, every knob true, every door closing like it cost a fortune.',
    image: 'https://cdn.magicpatterns.com/uploads/c9dDJtjnMZvEYhPN5oodMq/image.png',
    items: [
      'Cabinet pulls & knobs',
      'Door knobs & levers',
      'Deadbolts',
      'Electronic keypads',
      'Wi-Fi smart locks',
      'Bath accessories',
      'Hinges & adjustments',
      'Hardware sales & sourcing',
      'Soft-close upgrades'
    ]
  },
  {
    id: 'home',
    eyebrow: '02',
    title: 'Home Installation',
    description:
      'The upgrades that quietly transform a house. Structural, level, and anchored properly — installed once, correctly, with the finish left immaculate.',
    image: 'https://cdn.magicpatterns.com/uploads/ri9GA6HP4RH5ztWJSU82KH/image.png',
    items: [
      'Barn door installation',
      'Pocket doors',
      'Floating shelves',
      'Closet rods & systems',
      'House numbers',
      'Mailbox numbers',
      'Shower grab bars'
    ]
  },
  {
    id: 'mounting',
    eyebrow: '03',
    title: 'Mounting & Hanging',
    description:
      'Galleries, mirrors, televisions, and drapery — laser-set, centered, and secured. Cables concealed, walls patched, nothing left crooked.',
    image: 'https://cdn.magicpatterns.com/uploads/dNByXcZevwih3i6qVskH39/image.png',
    items: [
      'Hanging mirrors',
      'Hanging artwork',
      'TV mounting & cable concealment',
      'Mounting art & sculpture pieces',
      'Curtain & drape installation',
      'Window dressing installation'
    ]
  },
  {
    id: 'design',
    eyebrow: '04',
    title: 'Design & Consulting',
    description:
      'Finish schedules, hardware selection, and spec sheets built with your designer or builder — so the right pieces arrive on time and fit the first time.',
    image: 'https://cdn.magicpatterns.com/uploads/fuVwiSsYZnzcZ8geDD1YQb/image.png',
    items: [
      'Design & consulting',
      'Hardware selection & specification',
      'Finish & scale matching',
      'Professional installation services',
      'Trade & builder partnerships'
    ]
  }
]
